import type { CSSProperties } from "react";
import "./AttentionIndicator.css";

const MAX_DISPLAYED_COUNT = 99;

export type AttentionTone = "attention" | "error";
export type AttentionIndicatorProps = {
  tone: AttentionTone;
  label?: string;
  /** Ohne Zahl als Punkt; 0 blendet auch die Punktansicht aus. */
  count?: number;
  /** Kompakte Ansicht behält Zahl und Bedeutung für Screenreader bei. */
  dot?: boolean;
  /** Bewegung ausschließlich bei Fehlern; reduzierte Bewegung wird respektiert. */
  pulse?: boolean;
  className?: string;
  style?: CSSProperties;
};

/** Gemeinsames Aufmerksamkeitssignal: Hinweis und Fehler behalten in beiden Ansichten ihre Farbe (Werte aus dem Theme, `AttentionIndicator.css`). */
export function AttentionIndicator({ tone, label, count, dot = false, pulse = false, className, style }: AttentionIndicatorProps) {
  if (count != null && (!Number.isFinite(count) || count <= 0)) return null;
  const isDot = dot || count == null;
  const description = count == null ? label : label ? `${label}: ${count}` : String(count);
  return <span
    className={["mq-attention-indicator", `mq-attention-indicator--${isDot ? "dot" : "count"}`, `mq-attention-indicator--${tone}`, pulse && tone === "error" && "mq-attention-indicator--pulse", className].filter(Boolean).join(" ")}
    style={style}
    role="status"
    aria-label={description}
    title={description}
  >{isDot ? null : count! > MAX_DISPLAYED_COUNT ? `${MAX_DISPLAYED_COUNT}+` : count}</span>;
}
